import React from 'react';
import { Filter, RefreshCw } from 'lucide-react';

const CustomerFilter = ({ handleApply, handleReset, filters, setFilters }) => {
    return (
        <>
            <div className="bg-white rounded-lg shadow-sm mb-4">
                <div className="mb-4 border-b border-gray-300 px-6 py-4">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                        <div>
                            <h1 className="text-xl font-bold text-gray-900 mb-1">Customers</h1>
                            <p className="text-sm text-gray-600">Manage and monitor all customers</p>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-4 items-end px-6 md:grid-cols-2">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Search By</label>
                        <select
                            value={filters?.searchBy}
                            onChange={(searchBy) => { setFilters(prev => ({ ...prev, searchBy: searchBy.target.value })); }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option key="id" value="id">SSO ID</option>
                            <option key="email" value="email">Email ID</option>
                            <option key="mobile" value="mobile">Mobile Number</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Search</label>
                        <input
                            type="text"
                            value={filters?.searchTerm || ''}
                            onChange={(e) => setFilters(prev => ({ ...prev, searchTerm: e.target.value }))}
                            placeholder={filters?.searchBy === 'id' ? 'Enter SSO ID' : filters?.searchBy === 'email' ? 'Enter Email ID' : 'Enter Mobile Number'}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                </div>

                <div className='flex justify-between items-center px-6 py-3 mt-5 border-t border-gray-300'>
                    <p className="text-xs text-blue-600">Note: Enter an SSO ID, email, or mobile number and click Apply. The customer list loads only after you search.</p>
                    <div className="md:col-span-2 flex justify-end gap-3">
                        <button
                            onClick={handleApply}
                            className="px-4 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors flex items-center gap-2"
                        ><Filter className="size-3.5" />Apply
                        </button>
                        <button
                            onClick={handleReset}
                            className="px-4 py-2 bg-gray-500 text-white rounded-full hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors flex items-center gap-2"
                        > <RefreshCw className="size-3.5" /> Reset
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomerFilter;
